import React, { useState } from "react";
import {
  DataGrid,
  esES,
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
  GridCellParams,
  GridSortModel,
  GridPaginationModel,
  // GridToolbar,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Visibility from "@mui/icons-material/Visibility";
import TextField from "@mui/material/TextField";
import { useNavigate } from "react-router-dom";
import { ModalInvoiceComponent } from "../../components";
// import ArticleIcon from "@mui/icons-material/Article";
import FileDownload from "@mui/icons-material/FileDownload";
import { utils, writeFileXLSX } from "xlsx";

type TableProps = {
  columnData: GridColDef[];
  rowData: any[];
  actions?: boolean;
  actionsType?: string;
  onEdit?: (item: any) => void;
  onDelete?: (item: any) => void;
  exportTitle: string;
  hideSearch?: boolean; // Nueva prop para ocultar búsqueda
  serverPagination?: boolean;
  paginationModel?: GridPaginationModel;
  onPaginationModelChange?: (model: GridPaginationModel) => void;
  rowCount?: number;
  loading?: boolean;
};

export const TableComponent: React.FC<TableProps> = ({
  columnData,
  rowData,
  actions,
  actionsType,
  onEdit,
  onDelete,
  exportTitle,
  hideSearch = false, // Por defecto mostrar búsqueda
  serverPagination = false,
  paginationModel,
  onPaginationModelChange,
  rowCount = 0,
  loading = false,
}) => {
  const [filterValue, setFilterValue] = useState<string>("");
  const [isModalInvoiceOpen, setIsModalInvoiceOpen] = useState(false);
  // Comentadas porque handleModalInvoiceOpen está comentado
  // const [file, setFile] = useState<string>("");
  // const [product, setProduct] = useState<string>("");
  // const [facturas, setFacturas] = useState<string>("");

  const navigate = useNavigate();

  const handleEdit = (item: any) => {
    if (onEdit) {
      onEdit(item);
    }
  };

  const handleDelete = async (id: number) => {
    if (onDelete) {
      onDelete(id);
    }
  };

  // const handleModalInvoiceOpen = (row: any) => {
  //   setFile(row.file);
  //   setProduct(row.id);
  //   setFacturas(row);
  //   setIsModalInvoiceOpen(true);
  // };

  const handleModalInvoiceClose = () => {
    setIsModalInvoiceOpen(false);
  };

  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilterValue(event.target.value);
  };

  const filteredData = hideSearch
    ? rowData
    : rowData.filter((item) => {
        return Object.values(item).some((value) =>
          String(value).toLowerCase().includes(filterValue.toLowerCase())
        );
      });

  const MyCustomNoRowsOverlay = () => (
    <label
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      No se encontraron registros
    </label>
  );

  const columns: GridColDef[] = actions
    ? [
        {
          field: "actions",
          type: "actions",
          headerName: "Acciones",
          minWidth: actionsType === "products" ? 80 : 120,
          cellClassName: "actions",
          align: "center",
          headerAlign: "center",
          renderCell: (params: GridRenderCellParams) => {
            if (actionsType === "providers" || actionsType === "paymentsList") {
              const actions = [
                <GridActionsCellItem
                  key={"Edit"}
                  icon={<EditIcon />}
                  label="Editar"
                  className="textPrimary"
                  onClick={() => handleEdit(params.row)}
                  color="inherit"
                />,
                <GridActionsCellItem
                  key={"Delete"}
                  icon={<DeleteIcon />}
                  label="Eliminar"
                  onClick={() => handleDelete(params.row.id)}
                  color="inherit"
                />,
                <GridActionsCellItem
                  key={"Info"}
                  icon={<Visibility />}
                  label="Ver"
                  onClick={() =>
                    navigate(
                      actionsType === "providers"
                        ? `/proveedor/${params.row.id}`
                        : `/producto/${params.row.productoId}`
                    )
                  }
                />,
              ];
              return actions;
            } else if (actionsType === "payments") {
              const actions = [
                <GridActionsCellItem
                  key={"Edit"}
                  icon={<EditIcon />}
                  label="Editar"
                  className="textPrimary"
                  onClick={() => handleEdit(params.row)}
                  color="inherit"
                />,
                <GridActionsCellItem
                  key={"Delete"}
                  icon={<DeleteIcon />}
                  label="Eliminar"
                  onClick={() => handleDelete(params.row.id)}
                  color="inherit"
                />,
              ];
              return actions;
            } else if (actionsType === "products") {
              const actions = [
                <GridActionsCellItem
                  key={"Info"}
                  icon={<Visibility />}
                  label="Ver"
                  onClick={() => navigate(`/producto/${params.row.id}`)}
                />,
                <GridActionsCellItem
                  key={"Edit"}
                  icon={<EditIcon />}
                  label="Editar"
                  className="textPrimary"
                  onClick={() => handleEdit(params.row)}
                  color="inherit"
                />,
                <GridActionsCellItem
                  key={"Delete"}
                  icon={<DeleteIcon />}
                  label="Eliminar"
                  onClick={() => handleDelete(params.row.producto)}
                  color="inherit"
                />,
              ];
              return actions;
            }
          },
        },
        ...columnData,
      ]
    : columnData;

  function exportToExcel() {
    const wb = utils.book_new();
    utils.book_append_sheet(wb, utils.json_to_sheet(filteredData));
    writeFileXLSX(wb, exportTitle + ".xlsx");
  }

  const [sortModel, setSortModel] = React.useState<GridSortModel>([
    {
      field: "fechaVenta",
      sort: "desc",
    },
  ]);

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
      </GridToolbarContainer>
    );
  }

  // Configura el filtro inicial (opcional)
  // const [filterModel, setFilterModel] = React.useState({
  //   items: [{ columnField: "file", operatorValue: "contains", value: "" }],
  // });

  return (
    <div>
      {!hideSearch && (
        <TextField
          sx={{ width: "30%" }}
          label="Buscar"
          value={filterValue}
          onChange={handleFilterChange}
          style={{ marginBottom: 16, alignContent: "left" }}
        />
      )}
      <div style={{ height: 400, width: "100%" }}>
        <Button
          size="medium"
          variant="contained"
          sx={{ mt: 2, mb: 2 }}
          startIcon={<FileDownload />}
          onClick={exportToExcel}
        >
          Exportar
        </Button>
        <DataGrid
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          sx={{
            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
              width: "0.1em",
            },
            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track": {
              background: "#f1f1f1",
            },
            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
            },
            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover": {
              background: "#555",
            },
            "& .column_ars": {
              backgroundColor: "#b9d5ff91",
              //color: '#1a3e72',
              fontWeight: "600",
            },
            "& .column_usd": {
              backgroundColor: "rgba(157, 255, 118, 0.49)",
              //color: '#1a3e72',
              fontWeight: "600",
            },
            "& .hot": {
              backgroundColor: "#ff943975",
              //color: '#1a3e72',
            },
          }}
          loading={loading}
          pagination
          paginationMode={serverPagination ? "server" : "client"}
          rowCount={serverPagination ? rowCount : filteredData.length}
          paginationModel={serverPagination ? paginationModel : undefined}
          onPaginationModelChange={serverPagination ? onPaginationModelChange : undefined}
          sortingMode={serverPagination ? "server" : "client"}
          sortingOrder={["desc", "asc"]}
          sortModel={serverPagination ? undefined : sortModel}
          onSortModelChange={serverPagination ? undefined : (model) => setSortModel(model)}
          getCellClassName={(params: GridCellParams<any, any, number>) => {
            const rawValue = params.value as any;
            if (typeof rawValue !== "string") return "";
            if (
              (params.field === "saldo_ars" &&
                parseInt(rawValue.replace(/[^0-9]/g, "")) > 0) ||
              (params.field === "saldo_usd" &&
                parseInt(rawValue.replace(/[^0-9]/g, "")) > 0)
            ) {
              return "hot";
            }
            return "";
          }}
          slots={{
            noRowsOverlay: MyCustomNoRowsOverlay,
            toolbar: CustomToolbar,
          }}
          getRowId={(row) => row.id}
          getRowHeight={() => 45}
          rows={filteredData}
          columns={columns}
          autoHeight={true}
          initialState={
            serverPagination
              ? undefined
              : {
                  pagination: {
                    paginationModel: {
                      pageSize: 20,
                    },
                  },
                }
          }
          componentsProps={{
            pagination: {
              labelRowsPerPage: "Filas por página",
            },
          }}
          pageSizeOptions={[20, 50, 100]}
          disableRowSelectionOnClick
        />
      </div>

      <ModalInvoiceComponent
        open={isModalInvoiceOpen}
        onClose={handleModalInvoiceClose}
        title={"Facturas Asociadas"}
        productId={""}
        initialData={""}
      />
    </div>
  );
};


